<template>
  <div class="flex min-h-screen">
    <!-- 左側：表單區塊 -->
    <div class="flex-1 flex flex-col justify-center items-center bg-[#F0F9FF] dark:bg-gray-900 relative">
      <slot name="form"></slot>
      <!-- 語言選擇器 -->
      <div class="absolute top-4 right-4">
        <LanguageSelector />
      </div>
    </div>
    <!-- 右側：影片或是圖片 -->
    <div class="hidden md:flex w-[35%] bg-[#374151] dark:bg-gray-800 items-center justify-center">
      <slot name="media">
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import LanguageSelector from '~/components/common/LanguageSelector.vue';
</script>